import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { numberWithCommas } from 'helper';
import _ from 'lodash';
import { connect } from 'react-redux';
import * as actions from '../action';

function OtherFees({
  data,
  mode, handleMode,
  formSubmit, setFormData, formData,
  handleChangeInput, transactionStatus,
}) {
  const form = {
    otherFees: data,
  };

  const handleCancel = () => {
    setFormData(form);
    handleMode(0, 'OF');
  };

  const handleSubmit = () => {
    formSubmit(formData, 'OTHER_FEE');
  };
  return (
    <React.Fragment>
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0">Other Fees</h3>
        </div>
        <div className="col py-0 m-0 d-flex">
          {transactionStatus === 'FOR APPEARANCE' ? (
            <React.Fragment>
              {mode.otherFees === 0 ? (
                <button
                  type="button"
                  onClick={() => (handleMode(1, 'OF'))}
                  className="btn btn-secondary btn-round font-weight-bold px-4 ml-auto"
                >
                  Edit<i className="far fa-edit icon-edit p-0 ml-1" />
                </button>
              ) : (
                <React.Fragment>
                  <button
                    type="submit"
                    onClick={handleSubmit}
                    className="btn btn-primary cms-bg-color-primary cms-outline-primary     btn-round font-weight-bold px-4 mr-2 ml-auto"
                  >
                    Submit
                  </button>
                  <button
                    type="button"
                    onClick={handleCancel}
                    className="btn btn-secondary btn-round font-weight-bold px-4"
                  >
                    Cancel
                  </button>
                </React.Fragment>
              )}
            </React.Fragment>
          ) : ''}
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-12 pb-3">
          <div className="table-wrapper">
            <table>
              <thead>
                <tr>
                  <td>Type</td>
                  <td>Amount</td>
                </tr>
              </thead>
              <tbody>
                {_.isEmpty(data) ? (
                  <tr className="w-100">
                    <td colSpan="5" className="text-center border-top p-4 text-muted">
                      This Section is Empty
                    </td>
                  </tr>
                ) : (
                  <React.Fragment>
                    {mode.otherFees === 0 ? (
                      data.map(item => (
                        <tr key={item.id}>
                          <td className="border-top header-color">{_.get(item, 'name')}</td>
                          <td className="border-top">{numberWithCommas(_.get(item, 'amount') || 0)}</td>
                        </tr>
                      ))
                    ) : (
                      data.map(item => (
                        <tr key={item.id}>
                          <td className="border-top p-2">{_.get(item, 'name')}</td>
                          <td className="border-top p-2">
                            <input
                              className="form-control"
                              type="number"
                              id={item.capitalization}
                              onChange={handleChangeInput(item, 'amount')}
                              value={
                                _.get(
                                  _.find(formData, x => +x.id === +item.id) || {},
                                  'amount',
                                ) || ''
                              }
                            />
                          </td>
                        </tr>
                      ))
                    )}
                  </React.Fragment>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

OtherFees.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  mode: PropTypes.instanceOf(Object).isRequired,
  handleMode: PropTypes.instanceOf(Function).isRequired,
  handleChangeInput: PropTypes.instanceOf(Function).isRequired,
  formSubmit: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  transactionStatus: PropTypes.string,
};

OtherFees.defaultProps = {
  transactionStatus: '',
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(OtherFees);
